import React from 'react';
import Answers from './Answers';

class ComparableStateAnswers extends React.Component {
    render() {
        return (
            <div>
                <Answers answers={this.props.answers} stateCode={this.props.stateCode} id={this.props.id} />
            </div>
        );
    }

}


export default ComparableStateAnswers;


// WEBPACK FOOTER //
// ./src/components/ComparableStateAnswers.js